import { useCallback } from 'react'

import { useMutation } from '@tanstack/react-query'
import { ReportFile } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request/request'

import { handlerServerError } from '@orbit/errors'

type UploadReportFileRequest = {
  file: File
  reportMonthlyId?: number
  reportQuarterlyId?: number
}

const uploadReportFile = ({ file, reportMonthlyId, reportQuarterlyId }: UploadReportFileRequest) => {
  const form = new FormData()
  form.append('file', file)
  if (reportMonthlyId) {
    form.append('reportMonthlyId', reportMonthlyId.toString())
  }
  if (reportQuarterlyId) {
    form.append('reportQuarterlyId', reportQuarterlyId.toString())
  }
  return Request.post(Request.urls.bank.reportFileUpload, form)
}

export const useUploadReportFileCreate = (invalidate?: () => Promise<void>, reportQuarterlyId?: number) => {
  const { mutateAsync } = useMutation<ReportFile, Error, UploadReportFileRequest>({
    mutationFn: (opts) => uploadReportFile(opts),
    onSuccess: async () => {
      if (reportQuarterlyId && invalidate) invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  const createReportFile = useCallback(
    (payload: UploadReportFileRequest) =>
      mutateAsync({
        file: payload.file,
        reportMonthlyId: payload.reportMonthlyId,
        reportQuarterlyId: payload.reportQuarterlyId
      }),
    [mutateAsync]
  )

  return {
    createReportFile
  }
}
